import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';
import Login from '../pages/Public/Login';
import Register from '../pages/Public/Register';
import ValidateEmail from '../pages/Public/ValidateEmail';
import Plans from '../pages/Public/Plans';
import BillingSuccess from '../pages/Public/BillingSuccess';
import ForgotPassword from '../pages/Public/ForgotPassword';
import Home from '../pages/Private/Home';
import Account from '../pages/Private/Account';
import TradesHistory from '../pages/Private/TradesHistory';
import DepositsAndWithdraws from '../pages/Private/DepositsAndWithdraws';
import Insights, { InsightDetail } from '../pages/Private/Insights';
import TrialExpired from '../pages/Public/TrialExpired';
import ShareCard from '../pages/Public/ShareCard';
import AdminDashboard from '../pages/Admin/Dashboard';
import AdminUsers from '../pages/Admin/Users';
import AdminUserDetail from '../pages/Admin/UserDetail';
import AdminPayments from '../pages/Admin/Payments';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact isPrivate component={Home} />
      <Route path="/account" isPrivate component={Account} />
      <Route path="/history" isPrivate component={TradesHistory} />
      <Route
        path="/depositsAndWithdraws"
        isPrivate
        component={DepositsAndWithdraws}
      />
      <Route path="/insights/:id" isPrivate component={InsightDetail} />
      <Route path="/insights" exact isPrivate component={Insights} />

      <Route path="/admin" exact isAdmin component={AdminDashboard} />
      <Route path="/admin/users" exact isAdmin component={AdminUsers} />
      <Route path="/admin/users/:id" isAdmin component={AdminUserDetail} />
      <Route path="/admin/payments" isAdmin component={AdminPayments} />

      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/plans" isPrivate component={Plans} />
      <Route path="/billing/success" component={BillingSuccess} />
      <Route path="/trialExpired" component={TrialExpired} />
      <Route path="/validateEmail/:token" component={ValidateEmail} />
      <Route path="/forgotPassword/:token" component={ForgotPassword} />
      <Route path="/share/:token" component={ShareCard} />
      <Route component={Home} />
    </Switch>
  );
}
